import React from 'react';
import { motion } from 'framer-motion';
export function TheProblem() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-304">
      <div className="max-w-3xl mx-auto" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-306">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-307">
            LA PREGUNTA QUE NADIE SE ANIMA A HACERSE EN VOZ ALTA
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-308">
            <p className="font-bold text-gray-900 text-xl text-center" data-id="element-309">
              ¿Cuándo fue la última vez que te sacaste una foto de perfil nueva?
            </p>

            <p data-id="element-310">
              Si la respuesta es "hace mucho" o "evito sacarme fotos", ya sabés
              de qué te estoy hablando. El espejo, el flash, el desagüe lleno de
              pelos...
            </p>

            <p className="text-gold font-bold text-xl border-l-4 border-gold pl-4 py-2 my-6" data-id="element-311">
              Sentís que tu cuerpo te está traicionando. Y que no podés hacer
              nada al respecto.
            </p>

            <p data-id="element-312">
              Probaste shampoos, Minoxidil, todo. Y llegaste a la conclusión de
              que "es genética" y no hay nada que hacer.
            </p>

            <p className="font-bold text-gray-900" data-id="element-313">Esa conclusión está mal.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-gray-50 p-8 md:p-10 rounded-lg border border-gray-200" data-id="element-314">
          <h2 className="text-2xl md:text-3xl font-bold text-gold mb-6" data-id="element-315">
            LO QUE EN REALIDAD ESTÁ PASANDO EN TU CUERO CABELLUDO
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-316">
            <p data-id="element-317">
              Sí, la calvicie es genética en su predisposición. Pero la
              velocidad a la que avanza depende de factores que vos podés
              controlar: calcificación, fibrosis, DHT, falta de nutrientes y
              cortisol.
            </p>

            <p className="font-bold text-gray-900" data-id="element-318">
              Ninguno de esos factores es tu genética. Todos son atacables con
              ingredientes naturales de la dietética de tu barrio.
            </p>

            <p className="text-xl text-gold font-bold mt-4" data-id="element-319">
              Eso es exactamente lo que hace el Sistema Megakit: ADN Capilar
              Pro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}